export var REFRESH_STATE;

(function (REFRESH_STATE) {
  REFRESH_STATE[REFRESH_STATE["normal"] = 0] = "normal";
  REFRESH_STATE[REFRESH_STATE["pull"] = 1] = "pull";
  REFRESH_STATE[REFRESH_STATE["drop"] = 2] = "drop";
  REFRESH_STATE[REFRESH_STATE["loading"] = 3] = "loading";
  REFRESH_STATE[REFRESH_STATE["success"] = 4] = "success";
  REFRESH_STATE[REFRESH_STATE["failure"] = 5] = "failure";
})(REFRESH_STATE || (REFRESH_STATE = {}));

export var LOAD_STATE;

(function (LOAD_STATE) {
  LOAD_STATE[LOAD_STATE["normal"] = 0] = "normal";
  LOAD_STATE[LOAD_STATE["abort"] = 1] = "abort";
  LOAD_STATE[LOAD_STATE["loading"] = 2] = "loading";
  LOAD_STATE[LOAD_STATE["success"] = 3] = "success";
  LOAD_STATE[LOAD_STATE["failure"] = 4] = "failure";
  LOAD_STATE[LOAD_STATE["complete"] = 5] = "complete";
})(LOAD_STATE || (LOAD_STATE = {}));